import React, { useEffect, useState } from "react";
import creteImage from "../assets/images/crete.png";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/style.css";
import "../assets/css/bootstrap-datepicker.css";

import api, { IMAGE_BASE_URL } from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";

function HomePage() {
  // =====================================================
  // LANGUAGE
  // =====================================================

  const { translations, language } = useLanguage();
  const navigate = useNavigate();

  const bookingengine =
    translations?.bookingengine || {};

  // =====================================================
  // BACKEND
  // =====================================================

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL;

  // =====================================================
  // HOME CONTENT
  // =====================================================

  const [homeContent, setHomeContent] =
    useState({
      cont_title: "",
      cont_details: "",
    });

  const [whyChooseContents, setWhyChooseContents] =
    useState({
      page9: {
        cont_title: "",
        cont_details: "",
      },

      page10: {
        cont_title: "",
        cont_details: "",
      },

      page11: {
        cont_title: "",
        cont_details: "",
      },
    });

  const [loadingHomeContent, setLoadingHomeContent] =
    useState(true);

  const [loadingWhyChoose, setLoadingWhyChoose] =
    useState(true);

  // =====================================================
  // CAR DETAILS MODAL STATES
  // =====================================================

  const [selectedCarForDetails, setSelectedCarForDetails] =
    useState(null);

  const [showCarDetailsModal, setShowCarDetailsModal] =
    useState(false);

  // =====================================================
  // REMOVE EMPTY LIST ITEMS FROM DATABASE HTML
  // =====================================================

  const cleanContentHtml = (html) => {
    if (!html) {
      return "";
    }

    return String(html)
      .replace(/<li>\s*<\/li>/gi, "")
      .replace(
        /<li>(?:\s|&nbsp;|<br\s*\/?>)*<\/li>/gi,
        ""
      )
      .replace(
        /<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi,
        ""
      )
      .replace(
        /<div>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi,
        ""
      );
  };

  // =====================================================
  // BOOKING FORM STATES
  // =====================================================

  const [pickupLocation, setPickupLocation] =
    useState("");

  const [returnLocation, setReturnLocation] =
    useState("");

  const [pickupDate, setPickupDate] =
    useState("");

  const [pickupHour, setPickupHour] =
    useState("10");

  const [pickupMinute, setPickupMinute] =
    useState("00");

  const [returnDate, setReturnDate] =
    useState("");

  const [returnHour, setReturnHour] =
    useState("10");

  const [returnMinute, setReturnMinute] =
    useState("00");

  const [carType, setCarType] =
    useState("");

  const [driverAge, setDriverAge] =
    useState("0");

  const [clientId, setClientId] =
    useState("");

  const [clientEmail, setClientEmail] =
    useState("");

  const [bookingLoading, setBookingLoading] =
    useState(false);

  // =====================================================
  // LOCATION STATES
  // =====================================================

  const [locations, setLocations] =
    useState([]);

  const [loadingLocations, setLoadingLocations] =
    useState(false);

  // =====================================================
  // CAR STATES
  // =====================================================

  const [cars, setCars] =
    useState([]);

  const [loadingCars, setLoadingCars] =
    useState(true);

  // =====================================================
  // CAR CAROUSEL
  // =====================================================

  const CARDS_VISIBLE = 4;

  const [carouselIndex, setCarouselIndex] =
    useState(0);

  // =====================================================
  // HOURS
  // =====================================================

  const hours = [];

  for (let i = 0; i <= 23; i++) {
    hours.push(
      String(i).padStart(2, "0")
    );
  }

  // =====================================================
  // MINUTES
  // =====================================================

  const minutes = [
    "00",
    "15",
    "30",
    "45",
  ];

  // =====================================================
  // GET LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (
      typeof language === "number" ||
      !isNaN(Number(language))
    ) {
      return Number(language);
    }

    if (
      language &&
      typeof language === "object"
    ) {
      return (
        Number(
          language.lang_id ||
            language.language_id ||
            language.id
        ) || 1
      );
    }

    return 1;
  };

  const languageId =
    getLanguageId();

  // =====================================================
  // FETCH SINGLE CONTENT PAGE
  // =====================================================

  const fetchContentPage = async (
    pageId,
    langId
  ) => {
    try {
      const response =
        await api.get(
          "/contents/content",
          {
            params: {
              page_id: pageId,
              lang_id: langId,
            },
          }
        );

      const result =
        response.data;

      if (
        result &&
        result.success &&
        result.data
      ) {
        if (
          Array.isArray(
            result.data
          )
        ) {
          return (
            result.data[0] ||
            null
          );
        }

        return result.data;
      }

      return null;
    } catch (error) {
      console.error(
        `ERROR FETCHING PAGE ${pageId}:`,
        error
      );

      return null;
    }
  };

  // =====================================================
  // FETCH HOME PAGE - PAGE 12
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadHomeContent =
      async () => {
        setLoadingHomeContent(
          true
        );

        const content =
          await fetchContentPage(
            12,
            languageId
          );

        if (cancelled) {
          return;
        }

        if (content) {
          setHomeContent({
            cont_title:
              content.cont_title ||
              "",

            cont_details:
              content.cont_details ||
              "",
          });
        } else {
          setHomeContent({
            cont_title: "",
            cont_details: "",
          });
        }

        setLoadingHomeContent(
          false
        );
      };

    loadHomeContent();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // FETCH PAGE 9, 10, 11
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadWhyChooseContent =
      async () => {
        setLoadingWhyChoose(
          true
        );

        const [
          page9,
          page10,
          page11,
        ] = await Promise.all([
          fetchContentPage(
            9,
            languageId
          ),

          fetchContentPage(
            10,
            languageId
          ),

          fetchContentPage(
            11,
            languageId
          ),
        ]);

        if (cancelled) {
          return;
        }

        setWhyChooseContents({
          page9: {
            cont_title:
              page9?.cont_title ||
              "",

            cont_details:
              page9?.cont_details ||
              "",
          },

          page10: {
            cont_title:
              page10?.cont_title ||
              "",

            cont_details:
              page10?.cont_details ||
              "",
          },

          page11: {
            cont_title:
              page11?.cont_title ||
              "",

            cont_details:
              page11?.cont_details ||
              "",
          },
        });

        setLoadingWhyChoose(
          false
        );
      };

    loadWhyChooseContent();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // FETCH LOCATIONS
  // =====================================================

  useEffect(() => {
    fetchLocations();
  }, [languageId]);

  const fetchLocations = async () => {
    try {
      setLoadingLocations(
        true
      );

      const response =
        await api.get(
          "/locations/getLocations",
          {
            params: {
              city_id: 1,
              lang_id: languageId,
            },
          }
        );

      const result =
        response.data;

      if (
        result.success &&
        Array.isArray(
          result.data
        )
      ) {
        setLocations(
          result.data
        );
      } else {
        setLocations([]);
      }
    } catch (error) {
      console.error(
        "========== LOCATION ERROR =========="
      );

      console.error(
        "MESSAGE:",
        error.message
      );

      console.error(
        "CODE:",
        error.code
      );

      console.error(
        "RESPONSE:",
        error.response
      );

      console.error(
        "REQUEST:",
        error.request
      );

      setLocations([]);
    } finally {
      setLoadingLocations(
        false
      );
    }
  };

  // =====================================================
  // FETCH CARS
  // =====================================================

  useEffect(() => {
    fetchCars();
  }, [languageId]);

  const fetchCars = async () => {
    try {
      setLoadingCars(true);

      const response =
        await api.get(
          "/cars/getCars",
          {
            params: {
              lang_id: languageId,
            },
          }
        );

      const result =
        response.data;

      if (result.success) {
        setCars(
          Array.isArray(
            result.data
          )
            ? result.data
            : []
        );
      } else {
        setCars([]);
      }
    } catch (error) {
      console.error(
        "Error loading cars:",
        error
      );

      setCars([]);
    } finally {
      setLoadingCars(false);
    }
  };

  // =====================================================
  // RESET CAROUSEL
  // =====================================================

  useEffect(() => {
    setCarouselIndex(0);
  }, [
    languageId,
    cars.length,
  ]);

  // =====================================================
  // AUTO CAROUSEL
  // =====================================================

  useEffect(() => {
    if (
      cars.length <=
      CARDS_VISIBLE
    ) {
      return;
    }

    const slideInterval =
      setInterval(() => {
        setCarouselIndex(
          (prevIndex) => {
            const nextIndex =
              prevIndex + 1;

            if (
              nextIndex >
              cars.length -
                CARDS_VISIBLE
            ) {
              return 0;
            }

            return nextIndex;
          }
        );
      }, 3000);

    return () =>
      clearInterval(
        slideInterval
      );
  }, [cars.length]);

  // =====================================================
  // CAR IMAGE
  // =====================================================

  const getCarImage = (
    image
  ) => {
    if (!image) {
      return "";
    }

    let imagePath =
      String(image).trim();

    if (!imagePath) {
      return "";
    }

    if (
      imagePath.startsWith(
        "http://"
      ) ||
      imagePath.startsWith(
        "https://"
      )
    ) {
      return imagePath;
    }

    imagePath =
      imagePath.replace(
        /^\/+/,
        ""
      );

    if (
      imagePath.startsWith(
        "uploads/"
      )
    ) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (
      imagePath.startsWith(
        "cars/"
      )
    ) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (
      imagePath.startsWith(
        "images/"
      )
    ) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (
      imagePath.startsWith(
        "CarImage/"
      )
    ) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    return `${IMAGE_BASE_URL}/images/CarImage/${imagePath}`;
  };

  // =====================================================
  // IMAGE ERROR
  // =====================================================

  const handleImageError = (
    e,
    imageUrl
  ) => {
    console.error(
      "CAR IMAGE FAILED:",
      imageUrl
    );

    e.currentTarget.style.display =
      "none";

    const parent =
      e.currentTarget.parentElement;

    if (parent) {
      const fallback =
        parent.querySelector(
          ".image-fallback"
        );

      if (fallback) {
        fallback.style.display =
          "flex";
      }
    }
  };

  // =====================================================
  // BOOK NOW
  // =====================================================

  const handleBookNow = (
    car
  ) => {
    try {
      const selectedCarId =
        car.carmodel_id ||
        car.car_id ||
        car.id;

      const existingCriteria =
        sessionStorage.getItem(
          "bookingCriteria"
        );

      if (existingCriteria) {
        try {
          const criteria =
            JSON.parse(
              existingCriteria
            );

          criteria.selectedCarId =
            selectedCarId;

          criteria.selectedCar =
            car;

          sessionStorage.setItem(
            "bookingCriteria",
            JSON.stringify(
              criteria
            )
          );
        } catch (error) {
          console.error(
            "Unable to update booking criteria:",
            error
          );
        }
      }

      sessionStorage.setItem(
        "selectedCar",
        JSON.stringify(car)
      );

      // Close modal if opened
      setShowCarDetailsModal(
        false
      );

      setSelectedCarForDetails(
        null
      );

      navigate(
        "/cardetails"
      );
    } catch (error) {
      console.error(
        "BOOK NOW ERROR:",
        error
      );
    }
  };

  // =====================================================
  // DETAILS BUTTON
  // =====================================================

  const handleDetails = (
    car
  ) => {
    console.log(
      "DETAILS CAR:",
      car
    );
  console.log("========== FULL CAR DATA ==========");
  console.log(JSON.stringify(car, null, 2));
  console.log("===================================");
    setSelectedCarForDetails(
      car
    );

    setShowCarDetailsModal(
      true
    );
  };

  // =====================================================
  // CLOSE DETAILS MODAL
  // =====================================================

  const closeCarDetailsModal =
    () => {
      setShowCarDetailsModal(
        false
      );

      setSelectedCarForDetails(
        null
      );
    };

  // =====================================================
  // CLOSE MODAL WITH ESCAPE
  // =====================================================

  useEffect(() => {
    const handleEscape = (
      event
    ) => {
      if (
        event.key === "Escape"
      ) {
        closeCarDetailsModal();
      }
    };

    if (
      showCarDetailsModal
    ) {
      document.addEventListener(
        "keydown",
        handleEscape
      );
    }

    return () => {
      document.removeEventListener(
        "keydown",
        handleEscape
      );
    };
  }, [
    showCarDetailsModal,
  ]);

  // =====================================================
  // BOOKING SUBMIT
  // =====================================================

  const handleSubmit = async (
    e
  ) => {
    e.preventDefault();

    if (!pickupLocation) {
      alert(
        "Please select pickup location"
      );
      return;
    }

    if (!pickupDate) {
      alert(
        "Please select pickup date"
      );
      return;
    }

    if (!returnLocation) {
      alert(
        "Please select return location"
      );
      return;
    }

    if (!returnDate) {
      alert(
        "Please select return date"
      );
      return;
    }

    if (
      pickupDate &&
      returnDate &&
      new Date(returnDate) <
        new Date(pickupDate)
    ) {
      alert(
        "Return date cannot be before pickup date"
      );
      return;
    }

    try {
      setBookingLoading(
        true
      );

      const bookingCriteria = {
        cmbPickLocation:
          pickupLocation,

        pickdate:
          pickupDate,

        cmbpickHour:
          pickupHour,

        cmbpickmin:
          pickupMinute,

        cmbDropLocation:
          returnLocation,

        returndate:
          returnDate,

        cmbreturnHour:
          returnHour,

        cmbreturnmin:
          returnMinute,

        cmbcartype:
          carType,

        cmbdrvage:
          driverAge,

        clientid:
          clientId,

        clientemail:
          clientEmail,

        selectedlanguage:
          languageId,

        Editourcar: "",
      };

      console.log(
        "BOOKING CRITERIA:",
        bookingCriteria
      );

      sessionStorage.setItem(
        "bookingCriteria",
        JSON.stringify(
          bookingCriteria
        )
      );

      navigate(
        "/bookacar"
      );
    } catch (error) {
      console.error(
        "BOOKING SUBMIT ERROR:",
        error
      );
    } finally {
      setBookingLoading(
        false
      );
    }
  };

  // =====================================================
  // RETURN
  // =====================================================

  return (
    <div className="home-page">

      {/* =====================================================
          HERO / BOOKING AREA
      ====================================================== */}

      <div className="container-fluid p-0">

        <div className="row no-gutters">

          {/* LEFT PROMOTION */}

          <div
            className="
              col-xs-12
              col-sm-4
              col-md-4
              col-lg-4
              left-box
            "
            style={{
              background:
                "#014372 url('/images/background.png') no-repeat",
              backgroundSize:
                "contain",
              minHeight:
                "570px",
              padding:
                "20px",
            }}
          >

            <h2>
              Explore Crete
              <br />

              <span
                style={{
                  color:
                    "#ffe300",
                  fontSize:
                    "50px",
                  fontFamily:
                    "brusherregular",
                }}
              >
                Your Way
              </span>
            </h2>

            <p className="subline">
              Reliable cars, unbeatable prices and
              <br />
              freedom to explore every corner.
            </p>

            <ul
              style={{
                color:
                  "#fff",
              }}
            >
              <li>
                Best Price Guarantee
                <br />
                No hidden fees
              </li>

              <li>
                Unlimited Kilometers
                <br />
                Drive without limits
              </li>

              <li>
                24/7 Customer Support
                <br />
                We are here for you
              </li>
            </ul>

            <div className="p-box">

              <div
                className="
                  col-xs-12
                  col-sm-6
                  col-md-8
                  col-lg-8
                "
                style={{
                  float:
                    "left",
                  padding: 0,
                }}
              >

                <p className="offerline">
                  SPECIAL OFFER
                </p>

                <p className="p-line">

                  <span className="span">
                    -15%
                  </span>

                  <span className="online">
                    For online bookings
                  </span>

                </p>

              </div>

              <div
                className="
                  col-xs-12
                  col-sm-5
                  col-md-4
                  col-lg-4
                "
                style={{
                  float:
                    "left",
                  padding: 0,
                }}
              >

                <a
                  href="#booking-form"
                  className="butline"
                >
                  Book Now
                </a>

              </div>

              <div className="clearfix"></div>

            </div>

          </div>

          {/* RIGHT HERO */}

          <div
            className="
              col-xs-12
              col-sm-8
              col-md-8
              col-lg-8
            "
            style={{
              float:
                "left",
              padding: 0,
            }}
          >

            <div
              className="
                hero-wrap
                ftco-degree-bg
              "
              style={{
                minHeight:
                  "570px",
                position:
                  "relative",
              }}
            >

              <div className="container">

                <div
                  className="
                    row
                    no-gutters
                    slider-text
                    justify-content-start
                    align-items-center
                    justify-content-center
                  "
                >

                  <div className="col-lg-10">

                    <div
                      className="
                        text
                        w-100
                        text-center
                        mb-md-5
                        pb-md-5
                      "
                    >

                      <h1 className="mb-12">
                        Fast &amp; Easy Way To Rent A Car
                      </h1>

                      {/* BOOKING FORM */}

                      <div
                        className="
                          col-md-12
                          d-flex
                          align-items-center
                        "
                        id="booking-form"
                      >

                        <form
                          onSubmit={
                            handleSubmit
                          }
                          className="
                            request-form
                            bg-primary
                          "
                        >

                          {/* PICKUP */}

                          <div
                            className="col-md-6"
                            style={{
                              float:
                                "left",
                              padding: 0,
                            }}
                          >

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding:
                                  0,
                                textAlign:
                                  "left",
                              }}
                            >

                              <label className="label">
                                {bookingengine.bookingengine6 ||
                                  "PICK UP INFORMATION"}
                              </label>

                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding: 0,
                              }}
                            >

                              <div className="clearfix"></div>

                              <div
                                className="
                                  col-lg-12
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                                <div className="selectParent">

                                  <select
                                    className="arrow
                                      form-control
                                      selectParent
                                      select
                                    "
                                    name="cmbPickLocation"
                                    value={
                                      pickupLocation
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setPickupLocation(
                                        e.target
                                          .value
                                      )
                                    }
                                  >

                                    <option value="">
                                      {loadingLocations
                                        ? "Loading locations..."
                                        : bookingengine.bookingengine8 ||
                                          "Select location"}
                                    </option>

                                    {locations.map(
                                      (
                                        location
                                      ) => (
                                        <option
                                          key={
                                            location.loc_id
                                          }
                                          value={
                                            location.loc_id
                                          }
                                        >
                                          {
                                            location.loc_name
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                </div>

                              </div>

                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding: 0,
                              }}
                            >

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                            

                                <input
                                  type="date"
                                  name="pickdate"
                                  className="
                                    
                                    form-control
                                  "
                                  value={
                                    pickupDate
                                  }
                                  onChange={(
                                    e
                                  ) =>
                                    setPickupDate(
                                      e.target
                                        .value
                                    )
                                  }
                                />

                              </div>

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                                <div
                                  style={{
                                    display:
                                      "flex",
                                    gap:
                                      "3px",
                                  }}
                                >

                                  <select
                                    name="cmbpickHour"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={
                                      pickupHour
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setPickupHour(
                                        e.target
                                          .value
                                      )
                                    }
                                    style={{
                                      width:
                                        "50%",
                                    }}
                                  >

                                    {hours.map(
                                      (
                                        hour
                                      ) => (
                                        <option
                                          key={
                                            hour
                                          }
                                          value={
                                            hour
                                          }
                                        >
                                          {
                                            hour
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                  <select
                                    name="cmbpickmin"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={
                                      pickupMinute
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setPickupMinute(
                                        e.target
                                          .value
                                      )
                                    }
                                    style={{
                                      width:
                                        "50%",
                                    }}
                                  >

                                    {minutes.map(
                                      (
                                        minute
                                      ) => (
                                        <option
                                          key={
                                            minute
                                          }
                                          value={
                                            minute
                                          }
                                        >
                                          {
                                            minute
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                </div>

                              </div>

                            </div>

                          </div>

                          {/* RETURN */}

                          <div
                            className="col-md-6"
                            style={{
                              float:
                                "left",
                              padding: 0,
                            }}
                          >

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding:
                                  0,
                                textAlign:
                                  "left",
                              }}
                            >

                              <label className="label">
                                {bookingengine.bookingengine7 ||
                                  "RETURN INFORMATION"}
                              </label>

                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding: 0,
                              }}
                            >

                              <div
                                className="
                                  col-lg-12
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                                <div className="selectParent">

                                  <select
                                    className="arrow
                                      form-control
                                      selectParent
                                      select
                                    "
                                    name="cmbDropLocation"
                                    value={
                                      returnLocation
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setReturnLocation(
                                        e.target
                                          .value
                                      )
                                    }
                                  >

                                    <option value="">
                                      {loadingLocations
                                        ? "Loading locations..."
                                        : bookingengine.bookingengine8 ||
                                          "Select location"}
                                    </option>

                                    {locations.map(
                                      (
                                        location
                                      ) => (
                                        <option
                                          key={
                                            location.loc_id
                                          }
                                          value={
                                            location.loc_id
                                          }
                                        >
                                          {
                                            location.loc_name
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                </div>

                              </div>

                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float:
                                  "left",
                                padding: 0,
                              }}
                            >

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  ml-2
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                                <input
                                  type="date"
                                  name="returndate"
                                  className="
                                  
                                    form-control
                                  "
                                  value={
                                    returnDate
                                  }
                                  onChange={(
                                    e
                                  ) =>
                                    setReturnDate(
                                      e.target
                                        .value
                                    )
                                  }
                                />

                              </div>

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  ml-2
                                "
                                style={{
                                  float:
                                    "left",
                                  padding:
                                    "0px 9px 0px 0px",
                                }}
                              >

                                <div
                                  style={{
                                    display:
                                      "flex",
                                    gap:
                                      "3px",
                                  }}
                                >

                                  <select
                                    name="cmbreturnHour"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={
                                      returnHour
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setReturnHour(
                                        e.target
                                          .value
                                      )
                                    }
                                    style={{
                                      width:
                                        "50%",
                                    }}
                                  >

                                    {hours.map(
                                      (
                                        hour
                                      ) => (
                                        <option
                                          key={
                                            hour
                                          }
                                          value={
                                            hour
                                          }
                                        >
                                          {
                                            hour
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                  <select
                                    name="cmbreturnmin"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={
                                      returnMinute
                                    }
                                    onChange={(
                                      e
                                    ) =>
                                      setReturnMinute(
                                        e.target
                                          .value
                                      )
                                    }
                                    style={{
                                      width:
                                        "50%",
                                    }}
                                  >

                                    {minutes.map(
                                      (
                                        minute
                                      ) => (
                                        <option
                                          key={
                                            minute
                                          }
                                          value={
                                            minute
                                          }
                                        >
                                          {
                                            minute
                                          }
                                        </option>
                                      )
                                    )}

                                  </select>

                                </div>

                              </div>

                            </div>

                          </div>

                          {/* CAR TYPE + DRIVER AGE */}

                          <div
                            className="col-md-12"
                            style={{
                              padding: 0,
                              float:
                                "left",
                            }}
                          >

                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float:
                                  "left",
                                padding:
                                  "0px 9px 0px 0px",
                              }}
                            >

                             

                            </div>

                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float:
                                  "left",
                                padding:
                                  "0px 9px 0px 0px",
                              }}
                            >

                              

                            </div>

                          </div>

                          {/* BUTTONS */}

                          <div
                            className="col-md-12"
                            style={{
                              padding: 0,
                              float:
                                "left",
                            }}
                          >

                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float:
                                  "left",
                                padding:
                                  "0px 9px 0px 0px",
                              }}
                            >

                              <input
                                type="submit"
                                disabled={
                                  bookingLoading ||
                                  loadingLocations
                                }
                                value={
                                  bookingLoading
                                    ? "Loading..."
                                    : bookingengine.bookingengine9 ||
                                      "Continue"
                                }
                                className="
                                  btn
                                  btn-secondary1
                                  
                                "
                                style={{
                                  padding:
                                    "4px 0px",
                                }}
                              />

                            </div>

                            <div
                              className="col-md-6"
                              style={{
                                float:
                                  "left",
                                padding:
                                  "0px 9px 0px 0px",
                              }}
                            >

                              <a
                                href="/admin"
                                className="
                                  btn
                                  btn-secondary2
                                  py-3
                                  px-4
                                "
                              >
                                {bookingengine.bookingengine24 ||
                                  "Regular client Login"}
                              </a>

                            </div>

                          </div>

                        </form>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* =====================================================
          THREE FEATURE BADGES
      ====================================================== */}

      <section className="ftco-section ftco-about">

        <div className="container">

          <div
            className="
              col-xs-12
              col-sm-4
              col-md-4
              col-lg-4
            "
            style={{
              float:
                "left",
            }}
          >

            <div className="badge1 locationBadge">

              <b>
                Pick up &amp; Drop off at Major Locations
              </b>

              <span>
                We are based in Heraklion Airport and Chania
                Airport. You can collect and return your hired
                vehicle straight at any Crete's Airport.
              </span>

            </div>

          </div>

          <div
            className="
              col-xs-12
              col-sm-4
              col-md-4
              col-lg-4
            "
            style={{
              float:
                "left",
            }}
          >

            <div className="badge1 insurBadge">

              <b>
                Wide Range of Well-Maintained Cars
              </b>

              <span>
                We are based in Heraklion Airport and Chania
                Airport. You can collect and return your hired
                vehicle straight at any Crete's Airport.
              </span>

            </div>

          </div>

          <div
            className="
              col-xs-12
              col-sm-4
              col-md-4
              col-lg-4
            "
            style={{
              float:
                "left",
            }}
          >

            <div className="badge1 bookNowBadge">

              <b>
                Affordable Cost With No Hidden Charges
              </b>

              <span>
                We are based in Heraklion Airport and Chania
                Airport. You can collect and return your hired
                vehicle straight at any Crete's Airport.
              </span>

            </div>

          </div>

        </div>

        <div className="clearfix"></div>

      </section>

      {/* =====================================================
          CAR RENTAL DEALS
      ====================================================== */}

      <section
        className="
          ftco-section
          bg-light
        "
        style={{
          background:
            "#e0ecf7",
        }}
      >

        <div className="container">

          <div
            className="
              row
              justify-content-center
            "
          >

            <div
              className="
                col-md-12
                heading-section
                text-center
              "
            >

              <h2 className="mb-2">
                Cheap Crete Car Rental Deals
              </h2>

            </div>

          </div>

          {/* LOADING */}

          {loadingCars && (
            <div className="text-center">
              <p>
                Loading cars...
              </p>
            </div>
          )}

          {/* EMPTY */}

          {!loadingCars &&
            cars.length === 0 && (
              <div className="text-center">
                <p>
                  No cars available.
                </p>
              </div>
            )}

          {/* CARS */}

          {!loadingCars &&
            cars.length > 0 && (

              <div
                className="cars-carousel-viewport"
                style={{
                  overflow:
                    "hidden",
                  width:
                    "100%",
                }}
              >

                <div
                  className="cars-carousel-track"
                  style={{
                    display:
                      "flex",
                    flexWrap:
                      "nowrap",
                    transition:
                      "transform 0.6s ease-in-out",

                    transform:
                      `translateX(-${
                        carouselIndex *
                        (100 /
                          CARDS_VISIBLE)
                      }%)`,
                  }}
                >

                  {cars.map(
                    (
                      car,
                      index
                    ) => {

                      const carImage =
                        getCarImage(
                          car.image
                        );

                      const carName =
                        car.name ||
                        car.car_name ||
                        car.model_name ||
                        "Car";

                      const carCategory =
                        car.category ||
                        car.car_category ||
                        car.type ||
                        "";

                      const carPrice =
                        car.pricePerDay ??
                        car.price_perday ??
                        car.price ??
                        0;

                      const carId =
                        car.carmodel_id ||
                        car.car_id ||
                        car.vehicle_id ||
                        car.id ||
                        index;

                      return (
                        <div
                          className="mb-4"
                          key={
                            carId
                          }
                          style={{
                            flex:
                              `0 0 ${
                                100 /
                                CARDS_VISIBLE
                              }%`,

                            maxWidth:
                              `${
                                100 /
                                CARDS_VISIBLE
                              }%`,

                            padding:
                              "0 10px",

                            boxSizing:
                              "border-box",
                          }}
                        >

                          <div
                            className="
                              car-wrap
                              rounded
                            "
                            style={{
                              background:
                                "#fff",

                              overflow:
                                "hidden",

                              height:
                                "100%",
                            }}
                          >

                            {/* IMAGE */}

                            <div
                              className="
                                car-image-container
                              "
                              style={{
                                width:
                                  "100%",

                                height:
                                  "220px",

                                backgroundColor:
                                  "#fff",

                                display:
                                  "flex",

                                alignItems:
                                  "center",

                                justifyContent:
                                  "center",

                                overflow:
                                  "hidden",

                                position:
                                  "relative",
                              }}
                            >

                              <div
                                className="
                                  image-fallback
                                "
                                style={{
                                  width:
                                    "100%",

                                  height:
                                    "100%",

                                  display:
                                    carImage
                                      ? "none"
                                      : "flex",

                                  alignItems:
                                    "center",

                                  justifyContent:
                                    "center",

                                  color:
                                    "#999",

                                  fontSize:
                                    "14px",

                                  position:
                                    "absolute",

                                  top: 0,

                                  left: 0,
                                }}
                              >
                                No Image
                              </div>

                              {carImage && (
                                <img
                                  src={
                                    carImage
                                  }

                                  alt={
                                    carName
                                  }

                                  loading="lazy"

                                  style={{
                                    width:
                                      "100%",

                                    height:
                                      "220px",

                                    objectFit:
                                      "contain",

                                    objectPosition:
                                      "center",

                                    display:
                                      "block",

                                    position:
                                      "relative",

                                    zIndex:
                                      2,
                                  }}

                                  onError={(
                                    e
                                  ) =>
                                    handleImageError(
                                      e,
                                      carImage
                                    )
                                  }
                                />
                              )}

                            </div>

                            {/* CAR DETAILS */}

                            <div
                              className="text"
                              style={{
                                padding:
                                  "20px 12px 15px",
                              }}
                            >

                              <h2 className="mb-0">

                                <a
                                  href="#booking-form"
                                  onClick={(
                                    e
                                  ) => {
                                    e.preventDefault();

                                    handleDetails(
                                      car
                                    );
                                  }}
                                  style={{
                                    textDecoration:
                                      "none",
                                  }}
                                >
                                  {
                                    carName
                                  }
                                </a>

                              </h2>

                              <div
                                className="
                                  d-flex
                                  mb-3
                                "
                              >

                                <span className="cat">
                                  {
                                    carCategory
                                  }
                                </span>

                                <p
                                  className="
                                    eggPriceprice
                                    ml-auto
                                  "
                                >

                                  <span className="eggPrice">
                                    €
                                    {
                                      carPrice
                                    }
                                  </span>

                                  <span>
                                    /day
                                  </span>

                                </p>

                              </div>

                              <p
                                className="
                                  d-flex
                                  mb-0
                                  d-block
                                "
                              >

                                {/* BOOK NOW */}

                                <button
                                  type="button"
                                  className="
                                    btn
                                    btn-primary
                                    py-2
                                    mr-1
                                  "
                                  onClick={() =>
                                    handleBookNow(
                                      car
                                    )
                                  }
                                >
                                  Book now
                                </button>

                                {/* DETAILS */}

                                <button
                                  type="button"
                                  className="
                                    btn
                                    btn-secondary
                                    py-2
                                    ml-1
                                  "
                                  onClick={() =>
                                    handleDetails(
                                      car
                                    )
                                  }
                                >
                                  Details
                                </button>

                              </p>

                            </div>

                          </div>

                        </div>
                      );
                    }
                  )}

                </div>

              </div>
            )}

        </div>

      </section>

      {/* =====================================================
          WELCOME SECTION - PAGE 12
      ====================================================== */}

      <section
        className="
          about
          ftco-section
          ftco-about
        "
        style={{
          padding: 0,
        }}
      >

        <div className="container">

          <div className="row no-gutters">

            <div
              className="col-md-12"
              align="center"
            >

              <div
                className="
                  heading-section
                  heading-section-white
                "
              >

                <p
                  style={{
                    textAlign:
                      "center",

                    position:
                      "relative",

                    top:
                      "26px",

                    fontSize:
                      "20px",
                  }}
                >
                  Welcome to
                </p>

                <h2
                  className="aboutp"
                  style={{
                    textAlign:
                      "center",
                  }}
                >
                  {loadingHomeContent
                    ? "Loading..."
                    : homeContent.cont_title ||
                      "Our Crete Holidays car reservation"}
                </h2>

              </div>

            </div>

            <div
              className="col-md-6"
              align="center"
            >

              <img
                src={
                  creteImage
                }
                style={{
                  width:
                    "100%",
                }}
                alt="Crete"
              />

            </div>

            <div
              className="col-md-6"
              align="center"
            >

              <div
                className="
                  col-md-12
                  wrap-about
                "
                style={{
                  padding:
                    "0px 15px",
                }}
              >

                <div
                  className="
                    heading-section
                    heading-section-white
                  "
                  style={{
                    textAlign:
                      "left",
                  }}
                >

                  {loadingHomeContent ? (

                    <p>
                      Loading content...
                    </p>

                  ) : homeContent.cont_details ? (

                    <div
                      className="home-content-details"
                      dangerouslySetInnerHTML={{
                        __html:
                          homeContent.cont_details,
                      }}
                    />

                  ) : (

                    <p>
                      No content available.
                    </p>

                  )}

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          WHY CHOOSE STRIP
      ====================================================== */}

      <div className="whatspp">

        <div className="container">

          <div
            className="
              col-sm-12
              booking-box
            "
            style={{
              display:
                "block",
              padding: 0,
            }}
          >

            <div className="col-md-12">

              <p
                className="wtext"
                style={{
                  color:
                    "#fff",
                  fontSize:
                    "30px",
                  fontWeight:
                    600,
                  textAlign:
                    "center",
                }}
              >
                Why Choose Car Rental From Crete Holidays
              </p>

              <p
                style={{
                  color:
                    "#fff",
                  textAlign:
                    "center",
                  fontSize:
                    "19px",
                }}
              >

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; 100% Full insurance, &nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; No Extra cost on Arrival, &nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; No Hidden Excess,

                <br />

                &nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; No Credit Card Required, &nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; No Cancellation Fees, &nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; Book Easy Online Now,&nbsp;

                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color:
                      "#fbe00a",
                  }}
                ></span>

                &nbsp; No Prepayment Required

              </p>

            </div>

          </div>

        </div>

      </div>

      {/* =====================================================
          IMPORTANT TO KNOW
      ====================================================== */}

      <div className="ft-bg">

        <section className="why-choose-us-area">

          <div className="container">

            <div className="row">

              <div
                className="col-md-12"
                align="center"
              >

                <div
                  className="
                    heading-section
                    heading-section-white
                  "
                >

                  <p
                    style={{
                      textAlign:
                        "center",

                      position:
                        "relative",

                      top:
                        "26px",

                      fontSize:
                        "20px",
                    }}
                  >
                    Also
                  </p>

                  <h2
                    className="aboutp"
                    style={{
                      textAlign:
                        "center",
                    }}
                  >
                    Important to know
                  </h2>

                </div>

              </div>

            </div>

            <div className="row">

              {/* PAGE 9 */}

              <div
                className="col-md-6"
                style={{
                  padding:
                    "0 10px",

                  marginBottom:
                    "20px",
                }}
              >

                <div
                  className="
                    services
                    services-2
                    w-100
                  "
                  style={{
                    height:
                      "100%",
                  }}
                >

                  <div
                    className="
                      pr28
                      text-1
                      text
                      w-100
                    "
                    style={{
                      height:
                        "100%",
                    }}
                  >

                    <div
                      className="price-card"
                      style={{
                        height:
                          "100%",
                      }}
                    >

                      <div className="content">

                        <h2>
                          {loadingWhyChoose
                            ? "Loading..."
                            : whyChooseContents.page9
                                .cont_title ||
                              "Also important to know:"}
                        </h2>

                      </div>

                      {!loadingWhyChoose &&
                        whyChooseContents.page9
                          .cont_details && (

                          <div
                            className="why-content-page9"
                            dangerouslySetInnerHTML={{
                              __html:
                                cleanContentHtml(
                                  whyChooseContents
                                    .page9
                                    .cont_details
                                ),
                            }}
                          />

                        )}

                    </div>

                  </div>

                </div>

              </div>

              {/* PAGE 10 + PAGE 11 */}

              <div
                className="col-md-6"
                style={{
                  padding:
                    "0 10px",

                  marginBottom:
                    "20px",
                }}
              >

                <div
                  className="
                    pr28
                    services
                    services-2
                    w-100
                  "
                  style={{
                    height:
                      "100%",
                  }}
                >

                  <div
                    className="price-card1"
                    style={{
                      height:
                        "100%",
                    }}
                  >

                    {/* PAGE 10 */}

                    <div className="content">

                      <h2>
                        {loadingWhyChoose
                          ? "Loading..."
                          : whyChooseContents.page10
                              .cont_title ||
                            "Attention!!"}
                      </h2>

                    </div>

                    {!loadingWhyChoose &&
                      whyChooseContents.page10
                        .cont_details && (

                        <div
                          className="why-content-page10"
                          dangerouslySetInnerHTML={{
                            __html:
                              cleanContentHtml(
                                whyChooseContents
                                  .page10
                                  .cont_details
                              ),
                          }}
                        />

                      )}

                    <div className="clearfix" ></div>

                    {/* PAGE 11 */}

                    <div className="content">

                      <h2>
                        {loadingWhyChoose
                          ? "Loading..."
                          : whyChooseContents.page11
                              .cont_title ||
                            "Enjoy your holidays"}
                      </h2>

                    </div>

                    {!loadingWhyChoose &&
                      whyChooseContents.page11
                        .cont_details && (

                        <div
                          className="why-content-page11"
                          dangerouslySetInnerHTML={{
                            __html:
                              cleanContentHtml(
                                whyChooseContents
                                  .page11
                                  .cont_details
                              ),
                          }}
                        />

                      )}

                  </div>

                </div>

              </div>

            </div>

          </div>

        </section>

      </div>

      {/* =====================================================
          CAR DETAILS MODAL
      ====================================================== */}

 {/* =====================================================
    PROFESSIONAL CAR DETAILS MODAL
====================================================== */}

{showCarDetailsModal && selectedCarForDetails && (
  <div
    className="professional-car-modal-overlay"
    onClick={closeCarDetailsModal}
  >
    <div
      className="professional-car-modal"
      onClick={(e) => e.stopPropagation()}
    >

      {/* CLOSE BUTTON */}
      <button
        type="button"
        className="professional-car-modal-close"
        onClick={closeCarDetailsModal}
        aria-label="Close"
      >
        &times;
      </button>

      {/* =================================================
          LEFT IMAGE SECTION
      ================================================== */}

      <div className="professional-car-modal-left">

        <div className="professional-car-image-wrapper">

          {getCarImage(
            selectedCarForDetails.image
          ) ? (

            <img
              src={getCarImage(
                selectedCarForDetails.image
              )}
              alt={
                selectedCarForDetails.name ||
                selectedCarForDetails.car_name ||
                selectedCarForDetails.model_name ||
                "Car"
              }
              className="professional-car-image"
              onError={(e) => {
                e.currentTarget.style.display = "none";

                const fallback =
                  e.currentTarget.parentElement.querySelector(
                    ".professional-car-image-fallback"
                  );

                if (fallback) {
                  fallback.style.display = "flex";
                }
              }}
            />

          ) : null}

          <div
            className="professional-car-image-fallback"
            style={{
              display: getCarImage(
                selectedCarForDetails.image
              )
                ? "none"
                : "flex",
            }}
          >
            No Image Available
          </div>

        </div>

        {/* CATEGORY BADGE */}

        <div className="professional-car-category-badge">
          {selectedCarForDetails.category ||
            selectedCarForDetails.car_category ||
            selectedCarForDetails.type ||
            "Car"}
        </div>

      </div>

      {/* =================================================
          RIGHT CONTENT SECTION
      ================================================== */}

      <div className="professional-car-modal-right">

        {/* TITLE */}

        <div className="professional-car-header">

          <div>

            <span className="professional-car-small-title">
              CRETE HOLIDAYS
            </span>

            <h2>
              {selectedCarForDetails.name ||
                selectedCarForDetails.car_name ||
                selectedCarForDetails.model_name ||
                "Car Details"}
            </h2>

          </div>

          {/* PRICE */}

          <div className="professional-car-price">

            <span>
              €
              {selectedCarForDetails.pricePerDay ??
                selectedCarForDetails.price_perday ??
                selectedCarForDetails.price ??
                0}
            </span>

            <small>
              / day
            </small>

          </div>

        </div>

        {/* DESCRIPTION */}

        {(selectedCarForDetails.description ||
          selectedCarForDetails.details ||
          selectedCarForDetails.car_description) && (

          <div className="professional-car-description">

            <p>
              {selectedCarForDetails.description ||
                selectedCarForDetails.details ||
                selectedCarForDetails.car_description}
            </p>

          </div>

        )}

        {/* =================================================
            MAIN SPECIFICATIONS
        ================================================== */}

        <div className="professional-car-specifications">

          {/* PASSENGERS */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-user"></i>
            </div>

            <div>

              <small>
                Passengers
              </small>

              <strong>
                {selectedCarForDetails.passengers ??
                  selectedCarForDetails.no_of_passengers ??
                  selectedCarForDetails.seats ??
                  "N/A"}
              </strong>

            </div>

          </div>

          {/* LUGGAGE */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-suitcase"></i>
            </div>

            <div>

              <small>
                Luggage
              </small>

              <strong>
                {selectedCarForDetails.luggage ??
                  selectedCarForDetails.no_of_luggage ??
                  selectedCarForDetails.bags ??
                  "N/A"}
              </strong>

            </div>

          </div>

          {/* DOORS */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-key"></i>
            </div>

            <div>

              <small>
                Doors
              </small>

              <strong>
                {selectedCarForDetails.doors ??
                  selectedCarForDetails.no_of_doors ??
                  "N/A"}
              </strong>

            </div>

          </div>

          {/* TRANSMISSION */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-cog"></i>
            </div>

            <div>

              <small>
                Transmission
              </small>

              <strong>
                {selectedCarForDetails.transmission ??
                  selectedCarForDetails.gearbox ??
                  selectedCarForDetails.gear_type ??
                  "N/A"}
              </strong>

            </div>

          </div>

          {/* FUEL */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-gas-pump"></i>
            </div>

            <div>

              <small>
                Fuel
              </small>

              <strong>
                {selectedCarForDetails.fuel ??
                  selectedCarForDetails.fuel_type ??
                  selectedCarForDetails.fueltype ??
                  "N/A"}
              </strong>

            </div>

          </div>

          {/* AIR CONDITIONING */}

          <div className="professional-car-spec">

            <div className="professional-car-spec-icon">
              <i className="icon icon-snowflake-o"></i>
            </div>

            <div>

              <small>
                Air Conditioning
              </small>

              <strong>
                {selectedCarForDetails.airco ??
                  selectedCarForDetails.air_conditioning ??
                  selectedCarForDetails.ac ??
                  "Yes"}
              </strong>

            </div>

          </div>

        </div>

        {/* =================================================
            FEATURES
        ================================================== */}

        <div className="professional-car-features">

          <h4>
            Car Features
          </h4>

          <div className="professional-feature-list">

            <span>
              ✓ Unlimited Kilometers
            </span>

            <span>
              ✓ Full Insurance
            </span>

            <span>
              ✓ Free Cancellation
            </span>

            <span>
              ✓ 24/7 Customer Support
            </span>

            <span>
              ✓ No Hidden Charges
            </span>

            <span>
              ✓ Clean &amp; Well Maintained
            </span>

          </div>

        </div>

        {/* =================================================
            CAR ID
        ================================================== */}

        <div className="professional-car-id">

          <span>
            Vehicle ID
          </span>

          <strong>
            {selectedCarForDetails.carmodel_id ||
              selectedCarForDetails.car_id ||
              selectedCarForDetails.vehicle_id ||
              selectedCarForDetails.id ||
              "N/A"}
          </strong>

        </div>

        {/* =================================================
            BUTTONS
        ================================================== */}

        <div className="professional-car-modal-buttons">

          <button
            type="button"
            className="professional-book-button"
            onClick={() =>
              handleBookNow(
                selectedCarForDetails
              )
            }
          >
            <span>
              Book Now
            </span>

            <span className="professional-book-arrow">
              →
            </span>
          </button>

          <button
            type="button"
            className="professional-close-button"
            onClick={closeCarDetailsModal}
          >
            Close
          </button>

        </div>

      </div>

    </div>
  </div>
)}

    </div>
  );
}

export default HomePage;